import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  Spinner,
  Alert,
  ListGroup,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import api from "../../services/api";
import { formataDataHoraExibicao, getCurrentUser } from "../../common/utils";
import { toast } from "sonner";
import StatusBadge from "./StatusBadge";

const DetalheReporte = () => {
  const { reporteId } = useParams();
  const navigate = useNavigate();
  const [reporte, setReporte] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const dados_usuario = getCurrentUser();
  const isNavegadora = dados_usuario.tipo_usuario === "operador";

  useEffect(() => {
    const fetchReporte = async () => {
      try {
        const response = await api.get(`/formularios/respostas/${reporteId}/`);
        setReporte(response.data);
      } catch (err) {
        console.error("Erro ao buscar detalhes do reporte:", err);
        setError("Não foi possível carregar os detalhes do reporte.");
      } finally {
        setLoading(false);
      }
    };

    fetchReporte();
  }, [reporteId]);

  const handleCriarCopia = () => {
    const promise = () =>
      new Promise((resolve, reject) => {
        api
          .post(`/formularios/respostas/${reporteId}/derivar/`)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });

    toast.promise(promise, {
      loading: "Criando cópia para análise...",
      success: (response) => {
        navigate(`/reportes-farmaco/editar/${response.data.id}`);
        return "Cópia de trabalho criada com sucesso!";
      },
      error: (err) => {
        const errorMessage =
          err.response?.status === 409
            ? "Uma cópia para trabalho interno já existe para este reporte."
            : "Ocorreu um erro ao criar a cópia.";
        return errorMessage;
      },
    });
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  const nomePaciente =
    reporte.dados_beneficiario?.nome ||
    reporte.respostas?.paciente_nome_iniciais ||
    "-";

  return (
    <div>
      <Row className="align-items-center">
        <Col sm={6} lg={6}>
          <h4 className="page-title">
            Detalhes do Reporte de Farmacovigilância #{reporte?.id}
          </h4>
        </Col>
      </Row>
      <Card className="cardDestaque">
        <Card.Body>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <strong>Data de Envio:</strong>{" "}
              {formataDataHoraExibicao(reporte.data_cadastro)}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>Status:</strong> <StatusBadge status={reporte.status} />
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>Prestador:</strong>{" "}
              {reporte.dados_prestador?.nome || `ID ${reporte.prestador_id}`}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>Programa:</strong>{" "}
              {reporte.dados_programa?.nome || `ID ${reporte.programa_id}`}
            </ListGroup.Item>

            <ListGroup.Item>
              <strong>Paciente:</strong> {nomePaciente}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>Atendimento Vinculado:</strong>{" "}
              {reporte.dados_atendimento?.id || "-"}
            </ListGroup.Item>
          </ListGroup>

          <h6 className="mt-4">Respostas do Formulário</h6>
          <ListGroup variant="flush">
            {reporte.respostas &&
              Object.entries(reporte.respostas).map(([slug, valor]) =>
                slug === "paciente_nome_iniciais" &&
                reporte.dados_beneficiario ? null : (
                  <ListGroup.Item key={slug}>
                    <strong>
                      {slug
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase())}
                      :
                    </strong>
                    <p style={{ whiteSpace: "pre-wrap", margin: 0 }}>{valor}</p>
                  </ListGroup.Item>
                )
              )}
          </ListGroup>
        </Card.Body>
        <Card.Footer className="text-end">
          {/*isNavegadora && reporte.status === "enviado" && (
            <Button variant="info" onClick={handleCriarCopia}>
              Iniciar Análise (Criar Cópia)
            </Button>
          )*/}
          <Button
            variant="secondary"
            size="sm"
            className="ms-2"
            onClick={() => navigate("/reportes-farmaco")}
          >
            Voltar para a Lista
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default DetalheReporte;
